module.exports = __webpack_public_path__ + "img/ccl_gallery9.ad8a767f.jpg";